/* MEIBI · Landing de ofertas — fases por fecha (hora CDMX), contador, carrito y aviso de edad. Lievant, nov 2026 */
(function () {
  'use strict';
  var d = document, root = d.documentElement, body = d.body;
  var qs = function (s, c) { return (c || d).querySelector(s); };
  var qsa = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var P = function () { return new URLSearchParams(location.search); };

  /* ---------- Carrito (Shopify por defecto; la maqueta lo reemplaza) ---------- */
  var json = function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); };
  var post = function (url, data) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) }).then(json);
  };
  var Cart = window.LVCart || {
    get: function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(json); },
    add: function (items) { return post('/cart/add.js', { items: items }); },
    change: function (key, qty) { return post('/cart/change.js', { id: key, quantity: qty }); },
    checkout: function () { location.href = '/checkout'; }
  };

  var money = function (cents) {
    var n = Math.round(cents) / 100;
    return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };
  var toastEl = qs('.lv-toast'), toastT;
  var toast = function (msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  };

  /* ---------- Aviso de edad ---------- */
  var age = qs('.lv-age');
  if (age) {
    var ok = false;
    try { ok = localStorage.getItem('lv_18') === '1'; } catch (e) {}
    if (!ok) { age.hidden = false; body.style.overflow = 'hidden'; }
    qs('[data-lv-age-yes]', age).addEventListener('click', function () {
      try { localStorage.setItem('lv_18', '1'); } catch (e) {}
      age.hidden = true; body.style.overflow = '';
    });
    qs('[data-lv-age-no]', age).addEventListener('click', function () { location.href = 'https://www.google.com.mx'; });
  }

  /* ---------- Fases por fecha (America/Mexico_City, UTC-6 sin horario de verano) ---------- */
  var parseMx = function (s) {
    if (!s) return null;
    s = String(s).trim().replace(' ', 'T');
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) s += 'T00:00';
    if (/T\d{2}:\d{2}$/.test(s)) s += ':00';
    var t = Date.parse(s + '-06:00');
    return isNaN(t) ? null : t;
  };
  var now = function () {
    var f = P().get('lv_fecha');
    var t = f ? parseMx(f) : null;
    return t || Date.now();
  };
  var current = 'base';
  var pickFase = function () {
    var forced = P().get('fase');
    var list = qsa('[data-lv-fase]');
    if (forced && list.some(function (e) { return e.dataset.key === forced; })) return forced;
    var t = now(), key = null;
    list.forEach(function (e) {
      if (key) return;
      var a = parseMx(e.dataset.ini), b = parseMx(e.dataset.fin);
      if (a && b && t >= a && t < b) key = e.dataset.key;
    });
    return key || 'base';
  };
  var applyFase = function () {
    current = pickFase();
    root.setAttribute('data-lv-fase', current);
    qsa('[data-fase]').forEach(function (el) {
      var keys = el.getAttribute('data-fase').split(/[\s,]+/);
      el.hidden = !(keys.indexOf(current) > -1 || keys.indexOf('*') > -1);
    });
    var hasHero = qsa('.lv-hero [data-fase]').some(function (e) { return !e.hidden; });
    if (!hasHero) qsa('.lv-hero [data-fase~="base"]').forEach(function (e) { e.hidden = false; });
    startCountdown();
    maxOff();
  };

  /* ---------- Contador ---------- */
  var cdTimer;
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var startCountdown = function () {
    clearInterval(cdTimer);
    var cds = qsa('[data-lv-cd]').filter(function (e) { return e.offsetParent !== null || !e.closest('[hidden]'); });
    if (!cds.length) return;
    var tick = function () {
      var t = now() + (P().get('lv_fecha') ? (Date.now() - startedAt) : 0);
      cds.forEach(function (el) {
        var end = parseMx(el.getAttribute('data-lv-cd'));
        if (!end) { el.hidden = true; return; }
        var s = Math.max(0, Math.floor((end - t) / 1000));
        if (s === 0) { el.hidden = true; if (!P().get('fase')) { clearInterval(cdTimer); setTimeout(applyFase, 1500); } return; }
        var v = [Math.floor(s / 86400), Math.floor(s % 86400 / 3600), Math.floor(s % 3600 / 60), s % 60];
        qsa('b', el).forEach(function (b, i) { b.textContent = i === 0 ? v[0] : pad(v[i]); });
      });
    };
    tick(); cdTimer = setInterval(tick, 1000);
  };
  var startedAt = Date.now();

  /* ---------- «Hasta X%» calculado con los productos visibles ---------- */
  var maxOff = function () {
    var m = 0;
    qsa('.lv-card').forEach(function (c) {
      if (c.closest('[hidden]') || c.hidden) return;
      var o = parseInt(c.getAttribute('data-off'), 10) || 0; if (o > m) m = o;
    });
    if (m > 0) qsa('[data-lv-maxoff]').forEach(function (e) { e.textContent = m; });
  };

  /* ---------- Variantes ---------- */
  d.addEventListener('click', function (ev) {
    var v = ev.target.closest('.lv-var');
    if (!v || v.disabled) return;
    var card = v.closest('.lv-card');
    qsa('.lv-var', card).forEach(function (x) { x.classList.toggle('is-on', x === v); x.setAttribute('aria-checked', x === v ? 'true' : 'false'); });
    var add = qs('[data-lv-add]', card);
    add.setAttribute('data-id', v.dataset.id);
    var p = +v.dataset.price, cp = +v.dataset.cp;
    qs('.lv-price b', card).textContent = money(p);
    var s = qs('.lv-price s', card);
    if (s) { s.textContent = cp > p ? money(cp) : ''; }
    var bd = qs('.lv-badge', card);
    if (bd) { var off = cp > p ? Math.round((1 - p / cp) * 100) : 0; bd.textContent = '-' + off + '%'; bd.hidden = off < 5; }
  });

  /* ---------- Nombres seguros para el carrito (salen de las tarjetas, no del título de la tienda) ---------- */
  var names = {};
  var indexNames = function () {
    qsa('.lv-card').forEach(function (c) {
      var nm = c.getAttribute('data-name'), img = c.getAttribute('data-img');
      qsa('[data-id]', c).forEach(function (e) { names[e.dataset.id] = { n: nm, i: img }; });
    });
    qsa('[data-lv-kit-item]').forEach(function (e) { names[e.dataset.id] = { n: e.dataset.name, i: e.dataset.img }; });
  };
  var safeTitle = function (it) {
    var k = names[String(it.variant_id || it.id)];
    if (k && k.n) return k.n;
    return String(it.product_title || it.title || '').split('|')[0].trim();
  };

  /* ---------- Regalos por monto ---------- */
  var tiers = (function () {
    var el = qs('[data-lv-tiers]');
    var t = [];
    try { t = JSON.parse(el ? el.getAttribute('data-lv-tiers') : '[]'); } catch (e) {}
    if (!t.length) { var f = +(body.getAttribute('data-lv-free') || 0); if (f) t = [{ min: f, t: 'envío gratis' }]; }
    return t.sort(function (a, b) { return a.min - b.min; });
  })();
  var progress = function (total) {
    var pesos = total / 100, next = null, done = [];
    tiers.forEach(function (t) { if (pesos >= t.min) done.push(t); else if (!next) next = t; });
    var max = tiers.length ? tiers[tiers.length - 1].min : 1;
    var msg;
    if (!tiers.length) msg = '';
    else if (next) msg = 'Te faltan ' + money((next.min - pesos) * 100) + ' para ' + next.t;
    else { var lt = tiers[tiers.length - 1]; msg = lt.ok || ('¡Listo! Ya tienes ' + lt.t); }
    return { msg: msg, pct: Math.min(100, pesos / max * 100) };
  };

  /* ---------- Carrito lateral ---------- */
  var drawer = qs('.lv-cart'), sticky = qs('.lv-sticky'), last = null;
  var render = function (cart) {
    last = cart;
    qsa('[data-lv-count]').forEach(function (e) { e.textContent = cart.item_count; });
    var pr = progress(cart.total_price);
    qsa('[data-lv-prog-msg]').forEach(function (e) { e.textContent = cart.item_count ? pr.msg : (tiers.length ? 'Agrega productos y desbloquea ' + tiers[0].t : ''); });
    qsa('[data-lv-prog-bar]').forEach(function (e) { e.style.width = pr.pct + '%'; });
    qsa('[data-lv-subtotal]').forEach(function (e) { e.textContent = money(cart.total_price); });
    if (sticky) {
      sticky.classList.toggle('is-on', cart.item_count > 0);
      var st = qs('[data-lv-sticky-t]', sticky);
      if (st) st.innerHTML = '<b>' + cart.item_count + (cart.item_count === 1 ? ' producto · ' : ' productos · ') + money(cart.total_price) + '</b>' + (pr.msg || '');
    }
    var box = qs('.lv-cart__items', drawer);
    if (!box) return;
    if (!cart.items.length) { box.innerHTML = '<p class="lv-cart__empty">Tu carrito está vacío.</p>'; qs('[data-lv-checkout]', drawer).disabled = true; return; }
    qs('[data-lv-checkout]', drawer).disabled = false;
    box.innerHTML = cart.items.map(function (it) {
      var k = names[String(it.variant_id || it.id)] || {};
      var img = k.i || '';
      var vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      var price = it.final_line_price === 0 ? 'Regalo' : money(it.final_line_price);
      return '<div class="lv-ci">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="64" height="64" onerror="this.style.visibility=\'hidden\'">' : '<span class="lv-card__ph">meibi</span>') +
        '<div><h3>' + esc(safeTitle(it)) + '</h3>' + (vt ? '<p>' + esc(vt) + '</p>' : '') +
        (it.final_line_price === 0 ? '<p>Se agregó por el monto de tu compra</p></div>' :
        '<div class="lv-qty"><button type="button" data-lv-q="' + it.key + '" data-q="' + (it.quantity - 1) + '" aria-label="Quitar uno">−</button><span>' + it.quantity + '</span><button type="button" data-lv-q="' + it.key + '" data-q="' + (it.quantity + 1) + '" aria-label="Agregar uno">+</button></div></div>') +
        '<div class="lv-ci__p">' + price + '</div></div>';
    }).join('');
  };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var refresh = function () { return Cart.get().then(render).catch(function () {}); };
  var openCart = function () { if (!drawer) return; drawer.hidden = false; body.style.overflow = 'hidden'; var x = qs('.lv-x', drawer); if (x) x.focus(); };
  var closeCart = function () { if (!drawer) return; drawer.hidden = true; body.style.overflow = ''; };

  d.addEventListener('click', function (ev) {
    var t = ev.target;
    if (t.closest('[data-lv-open-cart]')) { ev.preventDefault(); openCart(); return; }
    if (t.closest('[data-lv-close-cart]')) { closeCart(); return; }
    var q = t.closest('[data-lv-q]');
    if (q) { Cart.change(q.getAttribute('data-lv-q'), Math.max(0, +q.dataset.q)).then(render); return; }
    if (t.closest('[data-lv-checkout]')) { Cart.checkout(); return; }
    var add = t.closest('[data-lv-add]');
    if (add) {
      ev.preventDefault();
      var ids = (add.getAttribute('data-ids') || add.getAttribute('data-id') || '').split(',').filter(Boolean);
      if (!ids.length) return;
      add.disabled = true;
      var label = add.textContent; add.textContent = 'Agregando…';
      Cart.add(ids.map(function (id) { return { id: +id, quantity: 1 }; }))
        .then(function () { return Cart.get(); })
        .then(function (cart) { render(cart); if (drawer) openCart(); else toast('Listo, ya está en tu carrito'); })
        .catch(function (e) { toast((e && (e.description || e.message)) || 'No se pudo agregar. Intenta de nuevo.'); })
        .then(function () { add.disabled = false; add.textContent = label; });
    }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && !drawer.hidden) closeCart(); });

  /* ---------- Categoría activa en la navegación ---------- */
  var navLinks = qsa('.lv-nav a');
  if ('IntersectionObserver' in window && navLinks.length) {
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        navLinks.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('href') === '#' + en.target.id); });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    navLinks.forEach(function (a) { var s = qs(a.getAttribute('href')); if (s) io.observe(s); });
  }
  /* Oculta en la navegación las categorías que se quedaron sin productos */
  navLinks.forEach(function (a) {
    var s = qs(a.getAttribute('href'));
    if (!s || (s.classList.contains('lv-grid') && !qs('.lv-card', s))) a.hidden = true;
  });

  window.LVLanding = { applyFase: applyFase, refresh: refresh, render: render, indexNames: indexNames, maxOff: maxOff };
  indexNames();
  applyFase();
  refresh();
})();
